export default class UtilID{

    static generateDateTimeID = () => {

        return new Date()?.getTime();

    }

}
